import { CertificationInterface } from '../interfaces/certification.interface';

export const CERTIFICATIONS: CertificationInterface[] = [
  {
    icon: 'security',
    title: 'ISO 27001',
    description: 'Ensures a robust information security management system.'
  },
  {
    icon: 'cloud_done',
    title: 'ISO 27017',
    description: 'Safeguards cloud services with advanced security controls.'
  },
  {
    icon: 'credit_card',
    title: 'PCI DSS',
    description: 'Protects your payment data with industry-leading standards.'
  },
  {
    icon: 'shield',
    title: 'F5',
    description: 'Delivers top-notch application and web security for seamless operations.'
  }
];